import React, { useMemo } from "react";
import { TUnstakeMode } from "./types";
import { EXCHANGE_LABELS, UNSTAKE_MODES } from "./config";
import { Typography } from "@kelp-dao/kernel-design-system";

const ModeOption = ({
  mode,
  isActive,
  onClick,
  disabled,
  instantWithdrawalFee,
}: {
  mode: TUnstakeMode;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
  instantWithdrawalFee?: number;
}) => {
  const modeConfig = UNSTAKE_MODES[mode];

  const displayFee = useMemo(
    () =>
      mode === "instant" && instantWithdrawalFee !== undefined
        ? `${instantWithdrawalFee}%`
        : modeConfig.fees,
    [mode, instantWithdrawalFee, modeConfig.fees]
  );

  const buttonClassName = useMemo(
    () =>
      `w-full rounded-xl transition-all text-left overflow-hidden ${
        isActive
          ? "border border-accent-highlight1"
          : "border border-border-default"
      } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`,
    [isActive, disabled]
  );

  const headerClassName = useMemo(
    () =>
      `flex items-center justify-center gap-1 px-4 pt-2 pb-1 ${
        isActive ? "bg-subbrand-background" : "bg-bg-primary"
      }`,
    [isActive]
  );

  return (
    <button
      onClick={onClick}
      className={buttonClassName}
      disabled={disabled}
    >
      <div className={headerClassName}>
        {modeConfig.icon && modeConfig.icon}
        <Typography
          type="body"
          variant="small"
          className="capitalize font-medium text-text-primary"
        >
          {modeConfig.displayName}
        </Typography>
      </div>

      <div className="px-4 py-2 space-y-1">
        <div className="flex justify-between">
          <Typography
            type="body"
            variant="xsmall"
            className="text-text-secondary"
          >
            {EXCHANGE_LABELS.waitingTime}
          </Typography>
          <Typography
            type="body"
            variant="xsmall"
            className="text-text-secondary"
          >
            {modeConfig.waitingTime}
          </Typography>
        </div>
        <div className="flex justify-between">
          <Typography
            type="body"
            variant="xsmall"
            className="text-text-secondary"
          >
            {EXCHANGE_LABELS.fees}
          </Typography>
          <Typography
            type="body"
            variant="xsmall"
            className="text-text-secondary"
          >
            {displayFee}
          </Typography>
        </div>
      </div>
    </button>
  );
};

export default React.memo(ModeOption);
